import { isCallback } from "@/isCallback";

export function genArray<T>(genFunc: () => Generator<T, void, unknown>): T[];
export function genArray<T>(genFunc: (index: number) => T, len: number): T[];
export function genArray<T>(
  genFunc: ((index: number) => T) | (() => Generator<T, void, unknown>),
  len?: number,
): T[] {
  if (typeof len === "number") {
    if (len < 0) {
      return [];
    }
    return Array.from({ length: len }, (_, i) => (genFunc as (index: number) => T)(i));
  }

  if (!isCallback<[], Generator<T, void, unknown>>(genFunc)) {
    throw new TypeError("genFunc must be a function");
  }

  return Array.from(genFunc());
}
